import PropTypes from 'prop-types';
import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import Track from '../../tracking/ZorseTicketInspectorTracker';
import { jsx as _jsx } from "react/jsx-runtime";
function CancelButton(props) {
  return /*#__PURE__*/_jsx(UIButton, {
    "data-test-id": "cancel-button-internal",
    onClick: () => {
      Track.filtersClosed();
      props.onClick();
    },
    use: "secondary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.filter.panel.cancel"
    })
  });
}
CancelButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(CancelButton);